import { render, staticRenderFns } from "./custom_list.vue?vue&type=template&id=6bc213a0&scoped=true&"
import script from "./custom_list.vue?vue&type=script&lang=js&"
export * from "./custom_list.vue?vue&type=script&lang=js&"
import style0 from "./custom_list.vue?vue&type=style&index=0&id=6bc213a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc213a0",
  null
  
)

export default component.exports